import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateProductSingle = {
  productSingle: { data: null, loading: false, error: null },
};

export const productSingle = createAsyncThunk('user/productSingle', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/product/${data.id}`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerProductSingle = {
  [productSingle.pending]: (state) => {
    state.productSingle.loading = true;
  },
  [productSingle.fulfilled]: (state, action) => {
    state.productSingle.loading = false;
    state.productSingle.data = action.payload;
    state.productSingle.error = null;
  },
  [productSingle.rejected]: (state, action) => {
    state.productSingle.data = null;
    state.productSingle.loading = false;
    state.productSingle.error = action.payload;
  },
};
